<template>
<div>
 <Header @getLanguageMap='getLanguageMap'></Header>
 
<NavigationBar></NavigationBar>
<img src="/images/cpzs.png" style="width: 100%;left: 0px;" id="bgId"/>

<div class="main">
   
  <div class="container">
   <div class="mainHead" style="width: 19.5%;float: left;border: 1px solid #eee;"> 
    
	<div v-for="(item,index) in shopTypeList" :key="index">
    <div v-if="item.show===1">
     <a :href="'/#/chanpin?id='+item.id+'&oneId='+oneId" @click="changeChanPin(item.id)" >
       <div class="child" :class="languageMap['fileName']=='chinese.txt'?'childCh':'childEn'" style="background-color: #eee;color: #333333;padding-left: 12px;">
		 <span :class="item.isSelected ? 'selectedMenuStyle' : ''">{{languageMap[item.name]}}</span>
		 <img :src="item.open ? '/images/xl.png' : '/images/sq.png'" @click="sszkClick(item)" style="float: right;padding-top: 10px;padding-right: 8px;"/>
       </div>
      </a>

	  <a v-show="item.open" v-for="(it,i) in item.childList" :key="i" :href="'/#/chanpin?id='+it.id+'&oneId='+oneId" @click="changeChanPin(it.id)" >
       <div class="child hoverText" :class="languageMap['fileName']=='chinese.txt'?'childCh2':'childEn2'" style="color: #333333;">
		 <span :class="it.isSelected ? 'selectedMenuStyle' : ''">{{languageMap[it.name]}}</span>
       </div>
      </a>
    </div>
	</div>  

    </div>

    <div class="productmain" style="width: 80%;float: left;">
	<a :href="'/#/chanpin/detail?id='+item.id+'&type='+item.type" v-for="(item,index) in shopList" :key="index">
      <div class="child">
        <div class="childImg">
			<img v-if="item.imgArr && item.imgArr.length > 0" :src="item.imgArr[0]">
			<span v-if="item.category==1"> 
            <img src="/images/Stop.png" style="width: 60px; position: absolute; height: 37px; left: 5px; top: 5px;" />  
            <span style="width: 50px; position: absolute; height: 40px; left: 8px; top: 14px; font-size: 12px; color: white; transform: rotate(-31deg); font-weight: bold; line-height: initial;">{{languageMap['停产']}}</span>
           </span>
           <span v-else-if="item.category==2">  
            <img src="/images/New.png" style="width: 40px; position: absolute; height: 40px; left: 5px; top: 5px;" />  
            <span style="width: 40px; position: absolute; height: 40px; left: 11px; top: 15px; font-size: 12px; color: white; transform: rotate(-31deg); font-weight: bold; line-height: initial;">{{languageMap['新品']}}</span>
           </span> 
		</div>
        <div class="childTitle">
          <p v-html="languageMap[item.name]"></p>
        </div>
        <div class="childSub"></div>
        <div class="childInfo"> <img src="/images/listicon.jpg"> <span>{{languageMap['详细信息']}}</span> </div>
      </div>
      </a>		
		 </div>

  </div>
</div>
 <Footer></Footer>
</div>
</template>

<style scoped>
.selectedMenuStyle{
  color: #2568f8 !important;
}

/* product2.css */
.main {
	padding:74px 0 90px 0;
}
/*product*/
.productmain .child {
	position:relative;
	float:left;
	width:227px;
	border:1px solid #e8e8e8;
	margin:0 0 10px 10px;
}
.productmain .child {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.productmain .child:hover {
	-webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-o-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
}
.productmain .child .childImg {
	width:100%;
	height:227px;
	line-height:227px;
	text-align:center;
}
.productmain .child .childImg img {
	vertical-align:middle;
	max-width:90%;
	max-height:90%;
}
.productmain .child .childImg img {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.productmain .child .childImg img:hover {
	transform:scale(1.04);
	-moz-transform:scale(1.04);
	-ms-transform:scale(1.04);
	-o-transform:scale(1.04);
	-webkit-transform:scale(1.04);
}
.productmain .child .childTitle {
	position:relative;
	height:60px;
	text-align:center;
}
.productmain .child .childTitle p {
	line-height:20px;
	padding-top:14px;
	color:#006FCF;
}
.productmain .child .childSub {
	height:5px;
	width:90%;
	margin:0 auto;
	border-top:1px solid #e5e5e5;
	border-bottom:1px solid #e5e5e5;
}
.productmain .child .childInfo {
	height:54px;
	line-height:54px;
	text-align:center;
	color:#006FCF;
	font-size:14px;
}
.productmain .child .childInfo img, .main .about .child .childInfo span {
	vertical-align:middle;
}
/*news*/
.mainContent .child {
	width:285px;
	margin-right:10px;
	vertical-align:text-top;
	padding-top:60px;
	display:inline-block;
*display:inline;
*zoom:1;
}
.mainContent .child .childImg {
	overflow:hidden;
	position:relative;
	width:285px;
	height:212px;
	line-height:212px;
	text-align:center;
}
.mainContent .child .childImg {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainContent .child:hover .childImg {
	-webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-o-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
}
.mainContent .child .childImg .childImgimg {
	width:100%;
	height:100%;
	vertical-align:middle;
}
.mainContent .child .childImg .childHide {
	opacity:0;
	position:absolute;
	top:0px;
	left:-100%;
	width:100%;
	height:100%;
	background-image: linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -o-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -moz-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -webkit-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -ms-linear-gradient(top, rgba(232,232,232, 0.8) 0%, rgba(214,214,214, 0.8) 100%);
	background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(232,232,232, 0.8)), color-stop(1, rgba(214,214,214, 0.8)));
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e8e8e8', endColorstr='#d6d6d6'), progid: DXImageTransform.Microsoft.Alpha(Opacity=0);
}
.mainContent .child .childImg .childHide {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainContent .child .childImg .childHide .childHideIcon {
	display:inline-block;
*display:inline;
*zoom:1;
	margin:0 2px;
	cursor:pointer;
	width:36px;
	height:36px;
	text-align:center;
	line-height:36px;
	border-radius:36px;
	-moz-border-radius:36px;
	-ms-border-radius:36px;
	-o-border-radius:36px;
	-webkit-border-radius:36px;
	background:#5f5f5f;
}
.mainContent .child .childImg .childHide .childHideIcon {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainContent .child .childImg .childHide .childHideIcon:hover {
	background:#000;
}
.mainContent .child .childImg .childHide .childHideIcon img {
	vertical-align:middle;
}
.mainContent .child .childImg:hover .childHide {
	left:0;
	opacity:1;
}
.mainContent .child .childTitle {
	line-height:24px;
	padding:20px 0 0 0;
	color:#333333;
	font-size:14px;
}
.mainContent .child .childTime {
	line-height:22px;
	padding:6px 0;
	color:#999999;
	font-size:12px;
}
.mainContent .child .childInfo {
	line-height:22px;
	font-size:12px;
	color:#666;
}
@media (max-width: 639px) {
.main {
	padding:30px 0 20px 0;
	text-align:center;
}
.main .child {
	width:288px;
	margin:10px auto;
	float:none;
	display:inline-block;
*display:inline;
*zoom:1;
}
.main .child .childImg {
	width:288px;
	height:288px;
	line-height:288px;
}
.main .child .childTitle {
	height:60px;
}
.main .child .childTitle p {
	line-height:20px;
	padding-top:14px;
}
.main .child .childSub {
	height:5px;
	width:250px;
}
.main .child .childInfo {
	height:54px;
	line-height:54px;
	font-size:14px;
}
}
@media (min-width: 640px) and (max-width:1023px ) {
.main {
	padding:36px 0 60px 0;
	text-align:center;
}
.main .child {
	width:288px;
	margin:6px 6px 0 0;
	float:none;
	display:inline-block;
*display:inline;
*zoom:1;
}
.main .child .childImg {
	width:288px;
	height:288px;
	line-height:288px;
}
.main .child .childTitle {
	height:60px;
}
.main .child .childTitle p {
	line-height:20px;
	padding-top:14px;
}
.main .child .childSub {
	height:5px;
	width:250px;
}
.main .child .childInfo {
	height:54px;
	line-height:54px;
	font-size:14px;
}
}
@media (min-width: 1024px) and (max-width:1199px ) {
.main {
	text-align:center;
}
.main .child {
	float:none;
	display:inline-block;
*display:inline;
*zoom:1;
}
}
@media (min-width: 1200px) and (max-width:1439px ) {
}
@media (min-width: 1440px) and (max-width:1920px ) {
}

/* vedio.css */
/* {{languageMap['简悦网络（www']}}.jianyuenet.com）{{languageMap['做最好的织梦模板网站 QQ']}}:780000068 */
.main .mainHead {
	/* height:50px;
	line-height:50px; */
	/* border-top:1px solid #e0e0e0;
	border-bottom:1px solid #e0e0e0; */
}
.main .mainHead .child {
	color:#666;
	float:left;
	line-height:35px;
	width: 95%;
}


.main .mainHead .childCh{
   font-size:16px;
}

.main .mainHead .childEn{
   font-size:13px;
}

.main .mainHead .childCh2{
   line-height: 30px;
font-size: 13px;
padding-left: 14px;
width: 95%;
}

.main .mainHead .childEn2{
   line-height: 30px;
   font-size: 12px;
   padding-left: 20px;
   width: 95%;
}

.main .mainHead .child.on {
	color:#7D2F8D;
}
.main .mainContent {
	display:none;
	padding:30px 0;
}
.main .mainContent .child {
	cursor:pointer;
	position:relative;
	margin:30px 35px;
	width:526px;
	display:inline-block;
*display:inline;
*zoom:1;
}
.main .mainContent .child .childImg {
	width:526px;
	height:295px;
	line-height:284px;
}
.main .mainContent .child .childImg .childBg {
	width:100%;
	height:100%;
	vertical-align:middle;
}
.main .mainContent .child .childImg .childIcon {
	cursor:pointer;
	position:absolute;
	z-index:1;
	top:50%;
	left:50%;
	width:50px;
	height:50px;
	margin:-25px 0 0 -25px;
}
.main .mainContent .child .childTitle {
	min-height:50px;
	background:#f1f1f1;
}
.main .mainContent .child .childTitle p {
	padding:12px 0;
	width:90%;
	text-align:center;
	line-height:22px;
	font-size:14px;
	color:#666;
}
 @media (max-width: 639px) {
.main .mainHead {
	height:30px;
	line-height:30px;
}
.main .mainHead .child {
	padding:0 4px;
	font-size:12px;
	line-height:30px;
	margin-right:6px;
}
.main .mainContent {
	padding:20px 0;
}
.main .mainContent .child {
	margin:12px 0;
	width:100%;
}
.main .mainContent .child .childImg {
	width:100%;
	height:auto;
	line-height:normal;
}
.main .mainContent .child .childImg .childIcon {
	width:30px;
	height:30px;
	margin:-15px 0 0 -15px;
}
.main .mainContent .child .childTitle {
	min-height:30px;
}
.main .mainContent .child .childTitle p {
	padding:8px 0;
	line-height:20px;
	font-size:12px;
}
}
@media (min-width: 640px) and (max-width:1023px ) {
.main .mainHead {
	height:50px;
	line-height:50px;
}
.main .mainHead .child {
	padding:0 18px;
	font-size:16px;
	line-height:50px;
	margin-right:44px;
}
.main .mainContent {
	padding:30px 0;
}
.main .mainContent .child {
	margin:30px 35px;
	width:526px;
}
.main .mainContent .child .childImg {
	width:526px;
	height:284px;
	line-height:284px;
}
.main .mainContent .child .childImg .childIcon {
	width:50px;
	height:50px;
	margin:-25px 0 0 -25px;
}
.main .mainContent .child .childTitle {
	min-height:50px;
}
.main .mainContent .child .childTitle p {
	padding:12px 0;
	line-height:22px;
	font-size:14px;
}
}
@media (min-width: 1024px) and (max-width:1199px ) {
.main .mainContent .child {
	margin:24px 28px;
	width:430px;
}
.main .mainContent .child .childImg {
	width:430px;
	height:232px;
	line-height:232px;
}
}
@media (min-width: 1200px) and (max-width:1439px ) {
}
@media (min-width: 1440px) and (max-width:1920px ) {
}

</style>

<script>
import store from "@/store";
import config from "@/config";
import Header from "@/components/front/Header.vue";
import Footer from "@/components/front/Footer.vue";
import NavigationBar from "@/components/front/NavigationBar.vue";

export default {
  data() {
    return {
		shopTypeList:[],
		shopTypeId:null,
    shopList:[],
	shopTypeObj:{},
	oneId: null,
      languageMap:{}
    };
  },
  mounted() {

	this.shopTypeId=this.$route.query.id;
	this.oneId = this.$route.query.oneId;
	this.queryAllShopType();
	this.addListener();
  },
  beforeDestroy(){

  },
    watch: {
　　// 利用watch方法检测路由变化：
　　'$route': function (to, from) {
　　　　// 拿到目标参数 to.query.id 去再次请求数据接口
    console.log('watch：'+to.query.id)
	this.shopTypeId=to.query.id;
	  if(this.oneId != to.query.oneId){
		this.oneId = to.query.oneId;
		this.queryAllShopType();
 	  }else {
		this.queryByParam();
		this.setMenuSelected(to.query.id);
	   }
　　}
},
  methods: {
	  setMenuSelected(id){
      if(this.shopTypeList){
      console.log('setMenuSelected id='+id+' len='+this.shopTypeList.length)
         for(let i=0; i < this.shopTypeList.length; i++){
           let oneMenu = this.shopTypeList[i];
		   oneMenu.isSelected = false;
		   oneMenu.open = false;
             if(oneMenu.id == id){
               oneMenu.isSelected = true;
 		       oneMenu.open = true;
             }
           if(oneMenu.childList){
             for(let j=0; j < oneMenu.childList.length; j++){
               let twoMenu = oneMenu.childList[j];
               twoMenu.isSelected = false;
               if(twoMenu.id == id){
                 oneMenu.isSelected = true;
                 twoMenu.isSelected = true;
 		         oneMenu.open = true;
               }
               if(twoMenu.childList){
                 for(let f=0; f < twoMenu.childList.length; f++){
                   let threeMenu = twoMenu.childList[f];
                   threeMenu.isSelected = false;
                   if(threeMenu.id == id){
                      oneMenu.isSelected = true;
                      twoMenu.isSelected = true;
					  threeMenu.isSelected = true;
 	   		          oneMenu.open = true;
                   }
                 }
               }
             }
           }
         }
       }
       this.$forceUpdate()
    },
	   addListener(){
        let _this=this;
        //this.languageMap['添加控件事件']
        window.addEventListener('chanpin', function(event){
			console.log(event.detail)
           _this.changeChanPin(event.detail?event.detail:null);
         });
	   },
    queryAllShopType(){
     let url =  config.url + "FrontController/queryAllShopTypeByPrentId.action";
      let param = {prentId: this.oneId,isQueryChild: true};
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
			this.shopTypeList=data.data || [];
			for(let i=0;i<this.shopTypeList.length;i++){
			  let shopTypeObj=this.shopTypeList[i];
			  shopTypeObj['open'] = false;
			}
			this.queryByParam();
			this.setMenuSelected(this.$route.query.id);
        }
      }) .catch(err => {
        console.log(err);
      });
   },
   queryByParam(){
    //  let url =  config.url + "FrontController/queryByParam.action";
	//   let param = {shopTypeId:this.shopTypeId};
	  let url =  config.url + "FrontController/queryByShopTypeIdList.action";
      let param = {type:this.shopTypeId};
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
		   this.shopList=data.data;
		   if(this.shopList){
			   for(let i=0; i < this.shopList.length; i++){
				 let shop = this.shopList[i];
				 if(shop.imgUrls){
					shop['imgArr'] = shop.imgUrls.split(',');
				 }
			   }
		   }
        }
      }) .catch(err => {
        console.log(err);
      });
     if(this.shopTypeId){ 
      for(let i=0;i<this.shopTypeList.length;i++){
        let shopTypeObj=this.shopTypeList[i];
         if(this.shopTypeId==shopTypeObj.id){
           this.shopTypeObj=shopTypeObj;
           break;
         }  
      }
     }else{
       this.shopTypeObj={};
     }
   },
   changeChanPin(shopTypeId){
	   this.shopTypeId=shopTypeId;
	   this.queryByParam();
   },
	getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
 sszkClick(obj){   //收缩或展开
   obj.open = !obj.open;
 },
    getLanguageMap(e){
      this.languageMap=e;
      this.$emit('getLanguageMap',e)
    }
  },
  components: {
    Header,
    Footer,
    NavigationBar
  }
};
</script>
